// src/comps/PaymentConfirmation.jsx
import React from "react";
import { Link } from "react-router-dom";

const PaymentConfirmation = () => {
  const methods = [
    {
      title: "United States (Zelle)",
      details: [
        "Email: abid32@hotmail.com",
        "Phone: 248-214-7122"
      ],
      isActive: true,
    },
    {
      title: "Canada (e-Transfer)",
      details: [
        "Email: syedarmanhussain@yahoo.com",
        "Phone: 1-647-888-1547"
      ],
      isActive: true,
    },
    {
      title: "Bangladesh (Bank Transfer)",
      details: [
        "⚠️ Details to be updated",
        "Bank Name: [PENDING]",
        "Account Number: [PENDING]",
        "Account Name: Spreeha BUET 88 Foundation"
      ],
      isActive: false,
    },
    {
      title: "United Kingdom",
      details: [
        "⚠️ Details to be updated",
        "Payment Method: [PENDING]",
        "Contact: [PENDING]"
      ],
      isActive: false,
    },
    {
      title: "Australia",
      details: [
        "⚠️ Details to be updated",
        "Payment Method: [PENDING]",
        "Contact: [PENDING]"
      ],
      isActive: false,
    },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col items-center py-12 px-4">
      <h1 className="text-4xl font-bold mb-4 text-black">Almost There!</h1>
      <p className="mb-8 text-center max-w-xl text-black">
        To finalize your membership, please choose the payment method below.
        Once we receive your payment, an administrator will activate your account.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 w-full max-w-4xl">
        {methods.map((m) => (
          <div
            key={m.title}
            className={`rounded-lg shadow-md p-6 flex flex-col ${
              m.isActive
                ? 'bg-[#800000]'
                : 'bg-gray-400 opacity-70'
            }`}
          >
            <h2 className="text-xl font-semibold mb-3 text-white">{m.title}</h2>
            <ul className="space-y-1 flex-1">
              {m.details.map((line, idx) => (
                <li key={idx} className="text-white">
                  {line}
                </li>
              ))}
            </ul>
            {!m.isActive && (
              <p className="text-white text-sm mt-3 italic">
                Coming soon - please use alternative payment methods
              </p>
            )}
          </div>
        ))}
      </div>

      <Link
        to="/"
        className="mt-12 bg-[#800000] text-white py-3 px-8 rounded-lg hover:bg-[#9b0000] transition"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default PaymentConfirmation;
